var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('basic-container',[_c('avue-tabs',{attrs:{"option":_vm.option},on:{"change":_vm.handleChange,"submit":_vm.handleSubmit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }